import { Hero } from "@/components/sections/Hero";
import { Marquee } from "@/components/sections/Marquee";
import { Legacy } from "@/components/sections/Legacy";
import { ClawGame } from "@/components/sections/ClawGame";
import { Manifesto } from "@/components/sections/Manifesto";
import { PartnerModels } from "@/components/sections/PartnerModels";
import { CategoryBento } from "@/components/sections/CategoryBento";
import { Showroom } from "@/components/sections/Showroom";
import { TotalSolution } from "@/components/sections/TotalSolution";
import { Industries } from "@/components/sections/Industries";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { Showcase } from "@/components/sections/Showcase";
import { WhyBrewer } from "@/components/sections/WhyBrewer";
import { Testimonials } from "@/components/sections/Testimonials";
import { LeadSection } from "@/components/sections/LeadSection";
import { ServiceSection } from "@/components/sections/ServiceSection";
import { FinalCTA } from "@/components/sections/FinalCTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <Legacy />
      <Manifesto />
      <PartnerModels index="01" />
      <CategoryBento index="02" />
      <Showroom index="03" />
      <ClawGame />
      <TotalSolution index="04" />
      <Industries index="05" />
      <HowItWorks index="06" />
      <Showcase index="07" />
      <WhyBrewer index="08" />
      <Testimonials index="09" />
      <LeadSection index="10" />
      <ServiceSection index="11" />
      <FinalCTA />
    </div>
  );
}
